import {nlSetting} from "./config/nl";

export const nlMoment = (moment: any) => {
    return moment.locale('nl', nlSetting);
}
